export const leads = {
  title: 'Lead-ek',
  subtitle: 'Potenciális ügyfelek kezelése',
  
  // Actions
  actions: {
    newLead: 'Új Lead',
    refresh: 'Frissítés',
    embed: 'Beágyazás',
    embedShort: 'Embed',
    edit: 'Szerkesztés',
    delete: 'Törlés',
    convert: 'Konvertálás',
    comments: 'Megjegyzések',
    viewComments: 'Megjegyzések megtekintése'
  },
  
  // Status
  status: {
    new: 'Új',
    contacted: 'Kapcsolatba lépve',
    qualified: 'Minősített',
    unqualified: 'Nem minősített',
    converted: 'Konvertálva',
    all: 'Összes'
  },
  
  // Source
  source: {
    website: 'Weboldal',
    manual: 'Manuális',
    referral: 'Ajánlás',
    social_media: 'Közösségi média',
    advertisement: 'Hirdetés',
    other: 'Egyéb'
  },
  
  // Table columns
  columns: {
    name: 'Név',
    contact: 'Kapcsolat',
    company: 'Cég',
    status: 'Státusz',
    source: 'Forrás',
    score: 'Pontszám',
    created: 'Létrehozva',
    actions: 'Műveletek'
  },
  
  // Form
  form: {
    title: {
      create: 'Új Lead',
      edit: 'Lead szerkesztése'
    },
    fields: {
      name: 'Név',
      namePlaceholder: 'Teljes név',
      email: 'Email',
      emailPlaceholder: 'email@example.com',
      phone: 'Telefon',
      phonePlaceholder: '+36 30 123 4567',
      company: 'Cég',
      companyPlaceholder: 'Cég neve',
      source: 'Forrás',
      score: 'Lead Pontszám (0-100)',
      scorePlaceholder: '0',
      scoreHelp: 'Minél magasabb a pontszám, annál valószínűbb a konverzió',
      notes: 'Megjegyzések',
      notesPlaceholder: 'További információk a lead-ről...'
    },
    sections: {
      basicInfo: 'Alapadatok',
      evaluation: 'Értékelés és Megjegyzések'
    },
    buttons: {
      cancel: 'Mégse',
      save: 'Mentés',
      create: 'Létrehozás'
    }
  },
  
  // Messages
  messages: {
    created: 'Lead sikeresen létrehozva!',
    updated: 'Lead sikeresen frissítve!',
    deleted: 'Lead sikeresen törölve!',
    statusUpdated: 'Státusz frissítve',
    converted: 'Lead sikeresen konvertálva ügyfélre!',
    error: 'Hiba történt',
    errorLoading: 'Hiba a lead-ek betöltésekor',
    errorCreating: 'Hiba a lead létrehozásakor',
    errorUpdating: 'Hiba a lead frissítésekor',
    errorDeleting: 'Hiba a lead törlésekor',
    errorStatus: 'Hiba a státusz frissítésekor',
    deleteConfirm: 'Biztosan törölni szeretnéd ezt a lead-et?',
    deleteWarning: 'Ez a művelet nem vonható vissza.',
    nameRequired: 'Kérlek add meg a nevet!'
  },
  
  // Search and filter
  search: {
    placeholder: 'Keresés név, email, cég vagy telefon alapján...',
    noResults: 'Nincs találat',
    resultsCount: '{count} találat'
  },
  
  // Empty states
  empty: {
    title: 'Nincs lead',
    subtitle: 'Kezdj el új lead-eket hozzáadni!',
    noResults: 'Nincs találat a keresési feltételeknek megfelelően'
  },
  
  // Conversion
  conversion: {
    title: 'Lead Konvertálása Ügyfélre',
    success: 'Lead sikeresen konvertálva ügyféllé!',
    error: 'Hiba a lead konvertálásakor'
  },
  
  // Comments
  comments: {
    title: 'Megjegyzések',
    add: 'Új megjegyzés',
    placeholder: 'Írj egy megjegyzést...',
    send: 'Küldés',
    delete: 'Megjegyzés törlése',
    deleteConfirm: 'Biztosan törölni szeretnéd ezt a megjegyzést?',
    empty: 'Még nincsenek megjegyzések',
    internal: 'Belső megjegyzés'
  },
  
  // Embed
  embed: {
    title: 'Lead űrlap beágyazása',
    description: 'Bal oldalon testreszabhatod az űrlapot, jobb oldalon pedig kimásolhatod a beágyazási kódot.',
    customize: 'Testreszabás',
    preview: 'Előnézet',
    code: 'Beágyazási kód',
    copy: 'Kód másolása',
    copied: 'Beágyazási kód másolva!'
  },
  
  // Pagination
  pagination: {
    showing: 'Megjelenítve',
    of: '/',
    results: 'találat',
    previous: 'Előző',
    next: 'Következő'
  }
};
